import React from "react";
import tw, { styled } from "twin.macro";
import { useStaticQuery, graphql, Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import SixthMan from "./SixthMan";

const Section = tw.section`relative w-full flex flex-col items-center`;
const Title = tw.h2`absolute top-0 text-center leading-none! text-primary opacity-[35%] text-6xl sm:text-9xl md:text-[11rem] lg:text-[15rem] xl:text-[18rem] 2xl:text-[22rem] leading-none italic font-mazuis z-20`;
const Spacer = tw.div`w-full relative h-[4.5rem] sm:h-[5rem] md:h-[7.5rem] lg:h-[10rem] xl:h-[12rem] 2xl:h-[15rem]`;
const Team = tw.div`flex flex-row w-full flex-wrap bg-dark`;

const TeamMember = styled(Link)`
  ${tw`relative flex flex-col items-center justify-center w-1/2 md:w-1/3 xl:w-1/6 overflow-hidden z-10 after:(content-[''] z-20 w-0 absolute bottom-0 left-0 right-0 mx-auto h-1 bg-gold duration-500 ease-in-out)`}

  .gatsby-image-wrapper {
    ${tw`w-full h-full duration-500 ease-in-out`}

    img {
      ${tw`w-full h-full object-cover! `}
    }
  }

  &:hover {
    ${tw`after:w-full`}

    .team-cta {
      ${tw`text-gold`}
    }

    .team-shadow {
      ${tw`opacity-40`}
    }

    .gatsby-image-wrapper {
      ${tw`scale-105 brightness-105`}
      img {
      }
    }
  }
`;

const YourTeam = ({ ...rest }) => {
  const { team, title } = useStaticQuery(graphql`
    {
      wp {
        acfOptionsMeetYourTeam {
          meetYourTeam {
            title: mytTitle
            team: mytTeamMembers {
              image {
                ...GatsbyImage_Blur
              }
              link {
                ...Button
              }
            }
          }
        }
      }
    }
  `).wp.acfOptionsMeetYourTeam.meetYourTeam;

  const teamWithFiller = [
    ...team,
    // {
    //   link: { url: "/why-hire-us/" },
    //   image: null,
    // },
  ];

  return (
    <Section {...rest}>
      <Title>{title}</Title>
      <Spacer />
      <Team>
        {teamWithFiller.map(({ link, image }, i) => (
          <TeamMember key={i} to={link.url}>
            {!!image?.localFile ? (
              <GatsbyImage
                image={getImage(image.localFile)}
                alt={image.altText}
              />
            ) : (
              <SixthMan />
            )}
          </TeamMember>
        ))}
      </Team>
    </Section>
  );
};

export default YourTeam;
